import * as React from 'react';

import {withStyles, WithStyles} from '@material-ui/core/styles';
import TranslateNew from '@translate/TranslateNew';
import { connect } from 'react-redux';
import Button from "@components/common/button/Button";
import { Dialog, } from '@material-ui/core';
import Subscription from '@components/subscription/Subscription';
import { ISubscription, SubscriptionPlatform } from '@app-types/websocket/subscription.types';
import { RouteComponentProps, withRouter  } from 'react-router-dom';
import { privatRoutesPathes } from '@router/router.constants';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import SubscriptionConnector from '@components/subscription/SubscriptionConnector';
import {PayWallStyle as styles} from './PayWall.style';




const tn :TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof styles>, RouteComponentProps {
  accountId:number;
  subscriptions:ISubscription[];
  myRole:FamilyMemberType;
  isFirstParent:boolean;
  online:boolean;
}

interface IState {
  boughtSubscription:number;
  dismissed:boolean;
}

class PayWall extends React.Component<IProps, IState> {

  public state = {
    boughtSubscription: 0,
    dismissed:false,
  };
  

  public render() {

    const atSchedules = this.props && this.props.location
      && (this.props.location.pathname.indexOf(privatRoutesPathes.SCHEDULES) > -1);
    const atChat = this.props && this.props.location &&
      (this.props.location.pathname.indexOf(privatRoutesPathes.MESSAGES) > -1);
    const atCalendar = this.props && this.props.location
      && (this.props.location.pathname.indexOf(privatRoutesPathes.CALENDAR) > -1);
    const atEconomy = this.props && this.props.location
      && (this.props.location.pathname.indexOf(privatRoutesPathes.ECONOMY) > -1);
    const atInfobank = this.props && this.props.location
      && (this.props.location.pathname.indexOf(privatRoutesPathes.INFOBANK) > -1);


    let lackSubscription:boolean = true;
    let hidePaywall = false

    for (const sub of this.props.subscriptions) {
      if (sub.platform === SubscriptionPlatform.CAMPAIGN ) {
        if (this.props.isFirstParent) {
          if (!(sub.expirationTime !== undefined && sub.expirationTime < (Date.now()+(1000*60*60*24*10)))) {
            lackSubscription = false;
          }
          if (!(sub.expirationTime !== undefined && sub.expirationTime < (Date.now()+(1000*60*60*24*3)))) {
            hidePaywall = true;
          }
        } else {
          if (!(sub.expirationTime !== undefined && sub.expirationTime < Date.now())) {
            lackSubscription = false;
          }
        }
      } else {
        if (!(sub.expirationTime !== undefined && sub.expirationTime < Date.now())) {
          lackSubscription = false;
        }
      }
    }
    
    let showPayWall:boolean = false;
    if (lackSubscription) {
      showPayWall = true;
    }
    if (hidePaywall) {
      showPayWall = false;
    } 
    if (this.props.online === false) {
      showPayWall = false;
    } 
    if (this.state.boughtSubscription > 0) {
      showPayWall = false;
    }
    if (!(atChat || atSchedules || atCalendar || atEconomy || atInfobank)) {
      showPayWall = false;
    }
    const canStartSubscription = this.props.myRole === FamilyMemberType.PARENT
      || this.props.myRole === FamilyMemberType.VIEWER;
    if (!canStartSubscription) {
      showPayWall = false;
    }
    if (!this.props.accountId ||this.props.accountId === 0) {
      showPayWall = false;
    }

    // console.log(this.props.accountId + " "+lackSubscription+" "+this.props.online);
    return (
      <>     
      {showPayWall && 
        <Dialog open={showPayWall} classes={{paper:this.props.classes.bigDialog}}>
          <div style={{ overflow: 'hidden', pointerEvents: 'none', maxWidth: '100%', maxHeight:'100%', minWidth: '100%',
              minHeight: '100%', position: 'absolute', top: 0, left: 0,}}>
            <div className={this.props.classes.circle}/>
          </div>
          <div style={{ margin: '20px 0px', fontSize: '32px', fontWeight: 700, zIndex:1,}}>
            {tn.lang.subscription}
          </div>
          <Subscription callBackSuccess={() => {this.setState({boughtSubscription:Date.now(), dismissed:true});}} />
         
        </Dialog>}
        {(this.props.accountId && lackSubscription && this.props.online) && <SubscriptionConnector accountId={this.props.accountId}/>}
      </>
    );
  }
  

}

const mapStateToProps = (state: any) => {
  const accountId = state.user.session.data.id;
  const subscriptions:ISubscription[] = (state.subscriptions.subscriptions?state.subscriptions.subscriptions:[]);
  const family: IFamilyMember[] = state.family.family?state.family.family:[];
  let myRole = FamilyMemberType.PARENT;
  let isFirstParent = true;
  if (family) {
    for (const mem of family) {
      if (mem.id < accountId && mem.role === FamilyMemberType.PARENT) {
        isFirstParent = false;
      }
      if (mem.id === accountId) {
        myRole = mem.role;
      }
    }
  }
  return {
    accountId,
    subscriptions,
    myRole,
    isFirstParent,
    online:state.connection.loadCompleted,
  };
};

export default connect(mapStateToProps, {})(withRouter((withStyles(styles)(PayWall))));



// WEBPACK FOOTER //
// ./src/components/common/paywall/PayWall.tsx